import { PencilSimpleIcon, TrashIcon } from '@phosphor-icons/react';
import { Button } from '../../../Utility/Button';
import usePromptFunctions from '../../../../Hooks/usePromptFunctions';
import AdminViewHeader from '../../../Utility/AdminViewHeader';
import { PromptFunction } from '../../../../Types';
import AdminViewContent from '../../../Utility/AdminViewContent';
import { RootState, useAppSelector } from '../../../../store';
import { UserSettings } from '../../../../Types';
import { PaginationListType } from '../../../../Types/PaginationParams';
import { connectorService } from '../../../../Services/connectorService';
import PaginatedView from '../../../Utility/PaginatedView';

function PromptFunctionsTab() {
    const settings = useAppSelector((state: RootState) => state.settings);
    const userSettings = useAppSelector((state: RootState) => state.userSettings as UserSettings);
    const { PromptFunctionsActions, handleNavigate, i18n, windowWidth, getBreakpoint } = usePromptFunctions();
    const GRID_COLS = 'grid-cols-[minmax(157px,300px),minmax(157px,1fr)]';

    return (
        <>
            <PaginatedView
                listType={PaginationListType.Connectors}
                itemsFunction={connectorService.getPromptFunctionsByPage}
                itemsPerPage={15}
                renderItem={(promptFunction: PromptFunction, index: number) => (
                    <AdminViewContent
                        key={promptFunction.identifier}
                        mobile={windowWidth < getBreakpoint('md')}
                        identifier={promptFunction.identifier}
                        gridCols={GRID_COLS}
                        cols={{
                            optionalCols: [
                                {
                                    content: promptFunction.title ?? '',
                                    image: promptFunction.image,
                                    showImage: true,
                                },
                            ],
                            button: {
                                buttons: [
                                    {
                                        variant:
                                            !settings.demo || userSettings.isSuperAdmin
                                                ? 'primaryRound'
                                                : 'disabledRound',
                                        onClick: () =>
                                            (!settings.demo || userSettings.isSuperAdmin) &&
                                            handleNavigate(promptFunction.identifier),
                                        icon: <PencilSimpleIcon />,
                                    },
                                    {
                                        variant:
                                            !settings.demo || userSettings.isSuperAdmin
                                                ? 'secondaryRound'
                                                : 'disabledRound',
                                        onClick: () =>
                                            (!settings.demo || userSettings.isSuperAdmin) &&
                                            PromptFunctionsActions.handleOpenConfirmDialog(promptFunction.identifier),
                                        icon: <TrashIcon />,
                                    },
                                ],
                            },
                        }}
                    />
                )}
                filterClassName="mb-4"
            >
                {({ list, filter }) => (
                    <>
                        {filter}

                        <div className="hidden md:block">
                            <AdminViewHeader
                                gridCols={GRID_COLS}
                                cols={{
                                    cols: [
                                        {
                                            text: i18n.translate({
                                                id: 'adminHeader.mainCol',
                                                sourceName: 'Main',
                                            }),
                                        },
                                    ],
                                    button:
                                        !settings.demo || userSettings.isSuperAdmin
                                            ? {
                                                  text: i18n.translate({
                                                      id: 'button.newFunction',
                                                      sourceName: 'PromptFunctions',
                                                  }),
                                                  function: () => handleNavigate('new'),
                                              }
                                            : undefined,
                                }}
                            />
                            <hr className="border-layout-borderColor mt-5" />
                        </div>
                        <div className="mb-4 md:hidden w-full">
                            {(!settings.demo || userSettings.isSuperAdmin) && (
                                <Button className="w-full mb-2" onClick={() => handleNavigate('new')}>
                                    {i18n.translate({
                                        id: 'button.newFunction',
                                        sourceName: 'PromptFunctions',
                                    })}
                                </Button>
                            )}
                        </div>

                        {list}
                    </>
                )}
            </PaginatedView>
        </>
    );
}

export default PromptFunctionsTab;
